// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint-disable quote-props */
export const VERSION = {
    "dirty": false,
    "raw": "f7e65ee",
    "hash": "f7e65ee",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "f7e65ee",
    "semverString": null,
    "version": "2026.11.2"
};
